import { useState, useEffect } from 'react';

const isMobileDevice = () => /iPad|iPhone|iPod|Android/.test(navigator.userAgent) || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
const useDetectKeyboardOpen = (ref, minKeyboardHeight = 300, defaultValue = false) => {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(defaultValue);
    useEffect(() => {
        if (!isMobileDevice()) {
            setIsKeyboardOpen(false);
        }
        const updateState = (newState) => {
            if (isKeyboardOpen !== newState) {
                setIsKeyboardOpen(newState);
            }
        };
        const onFocus = () => updateState(true);
        const onBlur = () => updateState(false);
        if (ref) {
            ref.addEventListener('focus', onFocus, true);
            ref.addEventListener('blur', onBlur, true);
        }
        return () => {
            if (ref) {
                ref.removeEventListener('focus', onFocus, true);
                ref.removeEventListener('blur', onBlur, true);
            }
        };
    }, [isKeyboardOpen, minKeyboardHeight, ref]);
    return isKeyboardOpen;
};

export { useDetectKeyboardOpen };
